import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheck, PiEye, PiUserCircle } from 'react-icons/pi';
import { IChatMessage } from 'services/chat/types';
import { useGetClientModuleConfiguration } from 'services/configuration';
import { useGetLabel } from 'services/labels';
import { formatMessageDate } from 'utils/global/date.utils';
import { getPlainText } from 'utils/global/plainText.utils';
import AttachmentsCard from '../attachments/AttachmentsCard';
import './MessageCard.scss';

interface IMessageCardProps {
  message: IChatMessage;
}

const MessageCard = ({ message }: IMessageCardProps) => {
  const { t } = useTranslation();

  const label = useGetLabel(false);

  const clientModuleConfiguration = useGetClientModuleConfiguration(false);

  const isOwner = useMemo(
    () => label.data?.id === message.senderId,
    [label.data?.id, message.senderId],
  );

  const className = classNames(['message-card-wrapper'], {
    isOwner,
  });

  return (
    <div className={className}>
      <div className='message-card-profile'>
        {isOwner ? (
          <PiUserCircle />
        ) : (
          <img
            src={
              clientModuleConfiguration.data?.currentLogoPath ??
              `${process.env.PUBLIC_URL}/icons/logo.svg`
            }
            alt=''
          />
        )}
      </div>
      <div className='message-card'>
        <div className='message-card-created'>
          {!isOwner &&
            clientModuleConfiguration.data?.clientName &&
            `${clientModuleConfiguration.data?.clientName} - `}
          {formatMessageDate(message.messageCreatedAt)}
        </div>
        {!!message.attachments.length && (
          <div className='message-card-attachemnts'>
            {message.attachments.map(a => (
              <AttachmentsCard key={a.id} attachment={a} backgroundColor />
            ))}
          </div>
        )}
        {!!getPlainText(message.body).length && (
          <div
            className='message-card-text message-text'
            dangerouslySetInnerHTML={{ __html: message.body }}
          />
        )}
        {isOwner && (
          <div
            className='message-card-read'
            title={formatMessageDate(
              message.readAt ? message.readAt : message.messageCreatedAt,
            )}>
            {message.readAt ? (
              <>
                {t('support.read')} <PiEye />
              </>
            ) : (
              <>
                {t('support.sent')} <PiCheck />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageCard;
